import InputErrors from "@/src/sb/components/Input/InputErrors"
import classNames from "classnames"
import AsyncSelect, {
  AsyncProps as ReactSelectAsyncProps
} from "react-select/async"
import { GroupBase } from "react-select/dist/declarations/src/types"

const SimpleAsyncSelect = <
  Option,
  isMulti extends boolean,
  Group extends GroupBase<Option>
>({
  removeInputBorder,
  errors,
  ...restProps
}: {
  removeInputBorder?: boolean
  errors?: string[]
} & ReactSelectAsyncProps<Option, isMulti, Group>) => {
  const showError = Boolean(errors?.length)

  return (
    <>
      <AsyncSelect
        unstyled
        menuPlacement={"auto"}
        blurInputOnSelect={true}
        menuShouldScrollIntoView={true}
        classNames={{
          container: () => "font-jakarta text-stears_black !min-w-max",
          menu: () => "bg-white shadow-sm !w-full !min-w-max",
          control: () =>
            classNames({
              "border border-border-20 hover:border-gray-600 focus-within:border-stears_black hover:border-stears_black py-3.5 sm:py-3 px-4":
                !removeInputBorder,
              "border-stears_danger text-stears_danger": showError
            }),
          option: () => "px-4 py-2.5 hover:bg-gray-50",
          placeholder: () => "text-gray-300",
          indicatorsContainer: () => "text-gray-500",
          noOptionsMessage: () => "px-4 py-2.5 text-blue-400",
          loadingMessage: () => "px-4 py-2.5 text-gray-500",
          ...restProps.classNames
        }}
        {...restProps}
      />
      {showError ? (
        <InputErrors errors={errors ?? []} name={restProps.name as string} />
      ) : null}
    </>
  )
}

export default SimpleAsyncSelect
